/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';
import Lookup from 'fierry/data/lookup';

import Anchor from 'solis/data/board/anchor';
import Sector from 'solis/data/board/sector';


export default class Colony extends Entity
{
  static children = [ 'sectors', 'influences', 'outboundAnchors', 'inboundAnchors' ];


  loadSector (cass)
  {
    return this.getSectors().load(cass.id, cass);
  }


  loadZone (cass)
  {
    return this.getSector(cass.sector).loadZone(cass);
  }


  loadInfluence (cass)
  {
    this.getInfluences().load(cass.targetZone, [ cass.targetZone, cass.sourceColony ]);
  }


  loadOutboundAnchor (cass)
  {
    return this.getOutboundAnchors().load(cass.targetColony, cass);
  }


  loadInboundAnchor (cass)
  {
    this.getInboundAnchors().load(cass.sourceColony, [ cass.sourceColony, cass.targetColony ]);
  }


  unloadSector (cass)
  {
    this.getSectors().unload(cass.id);
  }


  unloadZone (cass)
  {
    this.getSector(cass.sector).unloadZone(cass);
  }


  unloadInfluence (cass)
  {
    this.getInfluences().unload(cass.targetZone);
  }


  unloadOutboundAnchor (cass)
  {
    this.getOutboundAnchors().unload(cass.targetColony);
  }


  unloadInboundAnchor (cass)
  {
    this.getInboundAnchors().unload(cass.sourceColony);
  }


  createSector (colonySector)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.board = this.cass.board;
    cass.colony = this.cass.id;

    cass.id = colonySector.cass.id;
    cass.name = colonySector.cass.name;
    cass.transform = colonySector.cass.transform;

    cass.originUser = colonySector.cass.user;
    cass.currentUser = this.cass.user;

    cass.currency = colonySector.cass.currency;

    return this.parent.loadSector(cass);
  }


  createOutboundAnchor (targetColonyID)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.board = this.cass.board;

    cass.sourceColony = this.cass.id;
    cass.targetColony = targetColonyID;

    return this.parent.loadAnchor(cass);
  }


  getOriginUser ()
  {
    return this.parent.getUser(this.cass.user);
  }


  getOriginAccountView ()
  {
    return this.parent.getAccountView(this.cass.user);
  }


  getName ()
  {
    return this.getCoreSector().cass.name;
  }


  getCoreSector ()
  {
    return this.getSector(this.cass.id);
  }


  getSector (id)
  {
    return this.getSectors().at(id);
  }


  getSectors ()
  {
    return new Collection(Sector, this.cursor.child('sectors'), this.parent);
  }


  getInfluence (targetZone)
  {
    return this.getInfluences().at(targetZone);
  }


  getInfluences ()
  {
    return new Lookup(this.cursor.child('influences'), ([ targetZone, sourceColony ]) =>
    {
      return this.parent.getZone(targetZone).getInfluence(sourceColony);
    });
  }


  getOutboundAnchor (targetColonyID)
  {
    return this.getOutboundAnchors().at(targetColonyID);
  }


  getOutboundAnchors ()
  {
    return new Collection(Anchor, this.cursor.child('outboundAnchors'), this.parent);
  }


  getInboundAnchor (sourceColonyID)
  {
    return this.getInboundAnchors().at(sourceColonyID);
  }


  getInboundAnchors ()
  {
    return new Lookup(this.cursor.child('inboundAnchors'), ([ sourceColony, targetColony ]) =>
    {
      return this.parent.getColony(sourceColony).getOutboundAnchor(targetColony);
    });
  }


};
